import { render } from "./CreationTownView.vue?vue&type=template&id=8e5aab62"
import script from "./CreationTownView.vue?vue&type=script&lang=js"
export * from "./CreationTownView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__